// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-filter-opener[data-v-63a67aee]{padding:15px;border-bottom:1px solid #cfcfcf;margin:0;background-color:#fff;position:sticky;top:0;z-index:50}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
